<style>
  .aesthetic {
    display: flex;
    justify-content: end;
  }

  .aesthetic img {
    height: 10rem;
  }

  .imsg {
    border-radius: 1.15rem;
    line-height: 1.25;
    max-width: 75%;
    padding: 0.5rem .875rem;
    position: relative;
    word-wrap: break-word;
  }

  .imsg::before,
  .imsg::after {
    bottom: -0.1rem;
    content: "";
    height: 1rem;
    position: absolute;
  }

  .imsg {
    align-self: flex-start;
    background-color: #248bf5;
    color: #fff; 
  }

  .imsg::before {
    border-bottom-left-radius: 0.8rem 0.7rem;
    border-right: 1rem solid #248bf5;
    right: -0.35rem;
    transform: translate(0, -0.1rem);
  }

  .imsg::after {
    background-color: var(--bg);
    border-bottom-left-radius: 0.5rem;
    right: -40px;
    transform:translate(-30px, -2px);
    width: 10px;
  }
</style>

<div class="aesthetic">
  <p class="imsg">it's never <i>if</i> dumbathon, but <i>when</i> dumbathon</p>
  <img src="img/aesthetic.png" alt="aesthetic" />
</div>